interface Props {
  label: string
  value: number | null
  unit: string
  positiveLabel?: string  // e.g. "importing"
  negativeLabel?: string  // e.g. "exporting"
}

export function PowerCard({
  label,
  value,
  unit,
  positiveLabel,
  negativeLabel,
}: Props) {
  if (value === null) {
    return (
      <div className="power-card">
        <div className="power-label">{label}</div>
        <div className="power-value">
          <span className="power-unavailable">—</span>
        </div>
      </div>
    )
  }

  const isSigned = positiveLabel !== undefined || negativeLabel !== undefined
  const abs = Math.abs(value)
  const direction = isSigned
    ? value > 0
      ? positiveLabel
      : value < 0
        ? negativeLabel
        : 'balanced'
    : null

  const displayValue = isSigned ? abs : value

  return (
    <div className="power-card">
      <div className="power-label">{label}</div>
      <div className="power-value">
        <span className="power-number">{displayValue.toLocaleString()}</span>
        <span className="power-unit">{unit}</span>
      </div>
      {direction && <div className="power-direction">{direction}</div>}
    </div>
  )
}
